import { BaseApi } from '@/api/BaseApi.ts'
import type {
  BusinessData,
  BusinessFormData,
  BusinessFullData,
} from '@/api/Business/types.ts'
import type { FileUploadData, FileUploadResponse } from '@/api/File/types.ts'
import type { ApiFile, Paginated, ParamType } from '@/api/types.ts'
import { api } from '..'

class Api extends BaseApi<
  BusinessFullData,
  Paginated<BusinessData>,
  BusinessFormData
> {
  readonly baseUrl = '/business'

  async toggleState(id: ParamType): Promise<void> {
    const url = `${this.baseUrl}/${id}/toggle-state`
    const { data } = await api.put<void>(url)
    return data
  }

  async getFile(id: ParamType, fileUUID: string): Promise<Required<ApiFile>> {
    const url = `${this.baseUrl}/${id}/files/${fileUUID}`
    const { data } = await api.get<Required<ApiFile>>(url, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    })
    return data
  }

  async uploadFile({
    file,
    onUploadProgress,
  }: FileUploadData): Promise<FileUploadResponse> {
    const url = `${this.baseUrl}/files`
    const { data } = await api.post<FileUploadResponse>(url, file, {
      headers: {
        'content-type': 'multipart/form-data',
      },
      onUploadProgress,
    })
    return data
  }
}

const BusinessApi = new Api()

export default BusinessApi
